import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const PaginationWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border: ${({ active }) => (active ? 'none' : '1px solid #ccc')};
  background-color: ${({ active }) => (active ? colors.Blue300 : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#2c2c2c')};
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const PageButtonArrow = styled.button<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border: none;
  background-color: ${({ active }) => (active ? colors.text['sub-500'] : '#fff')};
  color: ${({ active }) => (active ? '#fff' : colors.text['sub-500'])};
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;
